import { render, staticRenderFns } from "./QuestionDetailTypes.vue?vue&type=template&id=57dfeed9&"
import script from "./QuestionDetailTypes.vue?vue&type=script&lang=js&"
export * from "./QuestionDetailTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports